import React, { useCallback, useEffect, useState } from 'react';
import { AppButton, Box, ShimmerBox, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import Permissions from '@/common/permissions';
import { Modal } from '@/components';
import { useHasAccess, useHistory } from '@/modules/core/hooks';

import { useGetRoleByIdQuery } from '../queries';
import { NO_ACCESS_ROLE_ID } from '../role.types';
import RoleSetupForm, { AffectedUsersCountSection } from '../RoleSetup/RoleSetupForm';
import FieldLevelAccessSection from '../RoleSetup/RoleSetupForm/FieldLevelAccessSection';
import PermissionsSection from '../RoleSetup/RoleSetupForm/PermissionsSection';
interface Props {
  id: string;
  onChangeId: (value: string) => void;
  onCopyModalOpen: (id: string) => void;
}
const RoleSummary: React.FC<Props> = ({ id, onChangeId, onCopyModalOpen }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (id) {
      setVisible(true);
    }
  }, [id]);
  const { data, isLoading } = useGetRoleByIdQuery({ id });
  const isAvailableToEdit = useHasAccess([
    {
      permission: Permissions.EDIT_ROLES_AND_SECURITY,
    },
  ]); 
  const handleSetVisible = useCallback(
    (value: boolean) => {
      if (!value) {
        onChangeId('');
      }

      setVisible(value);
    },
    [onChangeId]
  );

  const history = useHistory();
  const handleOpenEdit = useCallback(() => {
    history.push(ROUTES.ROLE_EDIT(id));
  }, [history, id]);

  const handleOpenCopyModal = useCallback(() => {
    onChangeId('');
    setVisible(false);
    onCopyModalOpen(id);
  }, [id, onChangeId, onCopyModalOpen]);
  return (
    <Modal testId='role-summary' visible={visible} onSetVisible={handleSetVisible} wrapperStyle={{ zIndex: 10000 }}>
      <RoleSetupForm
        key={data?.id}
        isViewMode
        defaultValues={data}
        isLoading={isLoading}
        title={
          isLoading ? (
            <ShimmerBox height="32px" width="220px" />
          ) : (
            <Text size="2xl" weight={700} margin={{ bottom: 'l' }} style={{ lineHeight: '32px' }}>
              { data?.name}
            </Text>
          )
        }
        footer={isAvailableToEdit ? (
          <Box  margin={{top: 'l'}} direction="row" justify="end">
            
            { id !== NO_ACCESS_ROLE_ID && (
              <AppButton width='160px' testId='role_copy' buttonType='secondary' onClick={handleOpenCopyModal}>
                Copy Permissions
              </AppButton>
            )}
            
            <Box margin={{left: 's'}}>
              <AppButton testId='role_edit'  disabled={isLoading} width='160px' onClick={handleOpenEdit} buttonType='primary'>
                Edit
              </AppButton>
            </Box>
          </Box>
        ): null}
      >
        <>
          <AffectedUsersCountSection 
            organizationId={data?.organizationId} 
            isLoading={isLoading}
            roleId={id} 
          />
          {id !== NO_ACCESS_ROLE_ID && (
            <FieldLevelAccessSection 
              isLoading={isLoading} 
              id={data?.fieldLevelAccessId}
            />
          )}
         
          <Box margin={{top: 'l'}} round="container1Round" background="canvas" pad="l" border={{ size: 'small', color: 'border1' }}>

            <PermissionsSection
              isLoading={isLoading}
              revoked={data?.revoked}
              granted={data?.granted}
            /> 
          </Box>
        </>
        
      </RoleSetupForm>
     
    </Modal>
  );
};

export default RoleSummary;
